import { HashLocationStrategy } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable()
export class ParameterHashLocationStrategy extends HashLocationStrategy {
  override prepareExternalUrl(internal: string): string {
    // console.log(
    //   'preparing external url',
    //   window.location.search,
    //   super.prepareExternalUrl(internal)
    // );
    return window.location.search + super.prepareExternalUrl(internal);
  }
}
